module.exports = __webpack_public_path__ + "img/reset-white.81b9890b.png";